import { __assign, __rest } from "tslib";
import React from 'react';
import { Checkbox } from '@chakra-ui/react';
var CheckboxComponent = function (_a) {
    var value = _a.value, onUpdateValue = _a.onUpdateValue, onChange = _a.onChange, defaultValue = _a.defaultValue, props = __rest(_a, ["value", "onUpdateValue", "onChange", "defaultValue"]);
    return (React.createElement(Checkbox, __assign({ defaultChecked: defaultValue, isChecked: value, onChange: function (e) {
            onUpdateValue && onUpdateValue(e.target.checked);
            onChange && onChange(e);
        } }, props)));
};
export default CheckboxComponent;
//# sourceMappingURL=CheckboxComponent.js.map